export const ENUM_TIPO_PERFIL = {
  ATENDENTE: 'ATENDENTE',
  SUPERVISOR: 'SUPERVISOR',
  SUPERVISOR_SETORIAL: 'SUPERVISORSETORIAL',
  CONTRIBUINTE: 'CONTRIBUINTE',
};

export const ENUM_PERMISSAO = {
  ATD01: {
    codigo: 'ATD01',
    descricao: 'Atendente - Pesquisar requerimento',
    identificador: 'ATD_PESQUISAR_REQUERIMENTO',
  },
  ATD02: {
    codigo: 'ATD02',
    descricao: 'Atendente - Pesquisar histórico',
    identificador: 'ATD_PESQUISAR_HISTORICO',
  },
  ATD03: {
    codigo: 'ATD03',
    descricao: 'Atendente - Detalhar requerimento',
    identificador: 'ATD_DETALHAR_REQUERIMENTO',
  },
  SUP01: {
    codigo: 'SUP01',
    descricao: 'Manter Atendente',
    identificador: 'SUP_MANTER_ATENDENTE',
  },
  SUP02: {
    codigo: 'SUP02',
    descricao: 'Pesquisar Atendente',
    identificador: 'SUP_PESQUISAR_ATENDENTE',
  },
  SUP03: {
    codigo: 'SUP03',
    descricao: 'Excluir Atendente',
    identificador: 'SUP_EXCLUIR_ATENDENTE',
  },
  SUP04: {
    codigo: 'SUP04',
    descricao: 'Incluir Atendente',
    identificador: 'SUP_INCLUIR_ATENDENTE',
  },
  SUP05: {
    codigo: 'SUP05',
    descricao: 'Supervisor - Pesquisar requerimento',
    identificador: 'SUP_PESQUISAR_REQUERIMENTO',
  },
  SUP06: {
    codigo: 'SUP06',
    descricao: 'Supervisor - Detalhar requerimento',
    identificador: 'SUP_DETALHAR_REQUERIMENTO',
  },
  SUP07: {
    codigo: 'SUP07',
    descricao: 'Supervisor - Pesquisar histórico',
    identificador: 'SUP_PESQUISAR_HISTORICO',
  },
  SUP08: {
    codigo: 'SUP08',
    descricao: 'Incluir Tipo de Serviço',
    identificador: 'INCLUIR_TIPO_DE_SERVICO',
  },
  SUP0801: {
    codigo: 'SUP0801',
    descricao: 'Editar Tipo de Serviço',
    identificador: 'EDITAR_TIPO_DE_SERVICO',
  },
  SUP0802: {
    codigo: 'SUP0802',
    descricao: 'Excluir Tipo de Serviço',
    identificador: 'EXCLUIR_TIPO_DE_SERVICO',
  },
  SUP09: {
    codigo: 'SUP09',
    descricao: 'Incluir Setor',
    identificador: 'INCLUIR_SETOR',
  },
  SUP0901: {
    codigo: 'SUP0901',
    descricao: 'Editar Setor',
    identificador: 'EDITAR_SETOR',
  },
  SUP0902: {
    codigo: 'SUP0902',
    descricao: 'Excluir Setor',
    identificador: 'EXCLUIR_SETOR',
  },
  SUP0903: {
    codigo: 'SUP0903',
    descricao: 'Listar Setor',
    identificador: 'LISTAR_SETOR',
  },
  SUP11: {
    codigo: 'SUP11',
    descricao: 'Incluir Postos de Atendimento',
    identificador: 'INCLUIR_POSTOS_ATENDIMENTO',
  },
  SUP1101: {
    codigo: 'SUP1101',
    descricao: 'Editar Postos de Atendimentos',
    identificador: 'EDITAR_POSTOS_ATENDIMENTO',
  },
  SUP1102: {
    codigo: 'SUP1102',
    descricao: 'Excluir Postos de Atendimentos',
    identificador: 'EXCLUIR_POSTOS_ATENDIMENTO',
  },
  CTD01: {
    codigo: 'CTD01',
    descricao: 'Contribuinte - Listar, pesquisar e detalhar requerimento',
    identificador: 'CTD_REQUERIMENTO_COMPLETO',
  },
};
